export default {
  documentStatuses: [],
};
